import React, { useState, useEffect, useRef, useMemo } from 'react'
import styled from 'styled-components';
import logo from '../../images/MegaPlazaBuilding.jpg';
import { delay } from '../../utils/delay';
import { addPayee, editPayee } from '../../redux/payeeSlice';
import { useDispatch } from 'react-redux';
import { currentDateLocale } from '../../utils/currentDate';
import { useSelector } from 'react-redux';
import { mobile } from '../../responsive';

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url(${logo})
      center;
      
  background-size: cover;
`

const Wrapper = styled.div`
    width: 60vw;
    background-color: white;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
                -10px -10px 30px rgba(9, 148, 255, 0.1), 
                inset -5px -5px 15px rgba(9, 148, 255, 0.5);

    ${mobile({
        width: '70vw',
    })};
`

const Title = styled.h1`
    text-decoration: underline;
    text-decoration-color: gray;
    text-underline-offset: 6px;
    margin: 5px;
    text-align: center;
`

const SubTitle = styled.h1`
    color: red;
    margin: 5px;
    font-size: 15px;
    
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
`

const FormRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'center',
    })};
`

const FormColumn = styled.div`

`

const FormLabel = styled.h1`
    font-size: 20px;
    font-weight: 300;
    margin: 5px;
    padding: 10px;
    
     ${mobile({
         textAlign: 'center'
     })}
`

const FormInput = styled.input`
    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;
    border-radius: 5px;
    border: none;
   
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
     &:hover, &:focus {
         box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                 -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
   
     }

    ${mobile({
        width: '60vw'
    })};
`

const FormSelect = styled.select`
    
    

    padding: 10px;
    margin: 5px;
    font-size: 20px;
    width: 300px;
    border-radius: 5px;
    border: none;
    box-shadow: 25px 25px 50px rgba(9, 148, 255, 0.25), 
    -10px -10px 30px rgba(9, 148, 255, 0.1), 
    inset -5px -5px 15px rgba(9, 148, 255, 0.5);
    
    &:hover, &:focus {
        box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    }

    /*&:first-child {
        color: gray;
    }*/

    ${mobile({
        width: '60vw'
    })};
`

const FormSelectOption = styled.option`
    
`

const Button = styled.button`
    padding: 10px 20px;
    margin: 30px 20px;
    border-radius: 10px;
    color: white;
    background: rgba(0, 200, 200, 0.9);
    cursor: pointer;
    border: none;
    font-size: 20px;
    font-weight: bold;
    box-shadow: 0 0.5rem 1rem rgba(0, 128, 128, 0.6), 
                inset 0.1rem 0.1rem 0.4rem rgba(0, 128, 128, 0.9), 
                inset -0.2rem -0.2rem 0.8rem rgba(0, 128, 128, 0.6);
    
    &:hover{
        box-shadow: none;
    }
`

const FormMessageBox = styled.h1`
    height: 20px;
    font-size: 20px;
    margin: 0;
    visibility: ${props => props?.messageType ? 'visible' : 'hidden'};
    color: ${props => props?.messageType === 1 ? 'green' : 'red'};
`

const Payee = ({payeeIdToEdit}) => {

    //console.log(payeeIdToEdit);
    const initialState = {
        'payeeId' : '',
        'payeeName' : '',
        'payeeDesc' : '',
        'payeeOwner' : '',
        'payeeBank' : '',
        'payeeBankId' : 0,
        'payeeAcct' : '',
        'updatedDate' : '',
        'createdDate' : ''
    };
    const [payee, setPayee] = useState(initialState);
    const [formMessage, setFormMessage] = useState({});
    const [edit, setEdit] = useState(false);
    const dispatch = useDispatch();
    const payeeRedux = useSelector(state => state.payeeRedux);
    const formRef = useRef();
    const payees = useMemo(() => [...payeeRedux?.payees], [payeeRedux?.payees]);
    const bankRedux = useSelector(state => state.bankRedux);

    const clearState = () => {
        setPayee({...initialState});
        setEdit(false);
    };

    useEffect(() => {

        if(payeeIdToEdit && payeeIdToEdit.payeeId && Number(payeeIdToEdit.payeeId) > 0){
            setEdit(true);
            const editPayee = payees?.filter((item) => item.payeeId === Number(payeeIdToEdit.payeeId));
            if(editPayee && editPayee[0]){
                setPayee(editPayee[0]);
            }
            
        }

        if(formRef.current){
            formRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ payeeIdToEdit]);

    const handleFormInput = (e) => {
        const {name, value} = e.target;

        if(name === 'payeeBankId'){
            const bank = bankRedux?.banks.filter((item) => item.bankId === Number(value));
            const bankName = bank[0] ? bank[0].bankName : '';
            setPayee({...payee, [name]: Number(value), 'payeeBank': bankName});
            
        }
        else{
            setPayee({...payee, [name]: value});
        }
        
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Create Payee Clicked');
        if (payee?.payeeName && payee?.payeeDesc) {
            console.log('No Errors');
            console.log({payee});
            if(edit){
                await dispatch(
                    editPayee({
                        ...payee, 
                        'updatedDate': currentDateLocale(),
                    })
                );
            }
            else{
                await dispatch(
                    addPayee({
                        ...payee,
                        'payeeId' : getNextAvailableId(), 
                        'createdDate': currentDateLocale(),
                    })
                );
            }

            await clearState();
            setFormMessage({'type' : 1, 'message' : 'Payee Saved Successfully'});
            //setDepartment({});

        } 
        else{
            console.log('Has Errors');
            setFormMessage({'type' : 2, 'message' : 'Some required fields are not filled'});
        }

        await delay(5000);

        setFormMessage({});

    }

    const getNextAvailableId = () => {
        return payeeRedux && payeeRedux.payees && payeeRedux.payees.length > 0 
            ? payeeRedux.payees[payeeRedux.payees.length - 1].payeeId + 1 : 1;
    };

    return (
        <Container ref={formRef}>
            <Wrapper>
                <Title>
                    {edit ? 'Edit Payee' : 'Create New Payee'}
                </Title>
                <SubTitle>
                    * == required
                </SubTitle>
                <FormMessageBox messageType={formMessage?.type}>
                    {formMessage?.message}
                </FormMessageBox>
                <Form>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Payee Name*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='payeeName'
                                        placeholder= 'Enter Payee Name'
                                        value = {payee.payeeName}
                                        onChange = {(e) => handleFormInput(e)} 

                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Payee Description*
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='payeeDesc'
                                        placeholder='Enter Payee Description'
                                        value={payee.payeeDesc}
                                        onChange={(e) => handleFormInput(e)}
                            />
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Payee Owner
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='payeeOwner'
                                        placeholder='Enter Payee Owner'
                                        value={payee.payeeOwner}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Payee Bank
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            
                            <FormSelect value={payee.payeeBankId}
                                        name='payeeBankId'
                                        onChange={(e) => handleFormInput(e)}>
                                <FormSelectOption key='0' value='0'>Select Bank</FormSelectOption>
                                {bankRedux?.banks?.map((item, index) => (
                                    <FormSelectOption key={item.bankId} value={item.bankId}>
                                        {item.bankName}
                                    </FormSelectOption>
                                ))}
                            </FormSelect>
                        </FormColumn>
                    </FormRow>
                    <FormRow>
                        <FormColumn>
                            <FormLabel>
                                Payee Account
                            </FormLabel>
                        </FormColumn>
                        <FormColumn>
                            <FormInput name='payeeAcct'
                                        placeholder='Enter Payee Account'
                                        value={payee.payeeAcct}
                                        onChange={(e) => handleFormInput(e)} />
                            
                        </FormColumn>
                    </FormRow>
                </Form>
                <Button onClick={(e) => handleSubmit(e)}>
                    {edit ? 'Edit Payee' : 'Create Payee'}
                </Button>
            </Wrapper>
        </Container>
    )
}

export default Payee
